/** finance-core — mẫu định kỳ theo số đã xác nhận của kỳ trước. Thuần hàm, có test. */
type Data = Record<string, any>;

/** Mẫu có tự lấy số đã xác nhận của kỳ trước không: theo cờ `followLastActual`; chưa đặt thì mẫu trả thẻ/nợ có, mẫu thu/chi không. */
export const followsLast = (t: Data): boolean => (t.followLastActual ?? t.type === 'payment') === true;

/** Số tiền của kỳ trước nếu khoản đó ĐÃ XÁC NHẬN (có `confirmedAmount`); ngược lại null → dùng số của mẫu. */
export const followedAmount = (t: Data, prev: Data | null | undefined): number | null =>
  followsLast(t) && prev && prev.status === 'confirmed' && Number(prev.confirmedAmount) > 0 ? Math.round(Number(prev.confirmedAmount)) : null;

/** Kỳ liền trước của một mẫu: tháng trước (hằng tháng) hoặc cùng tháng năm trước (hằng năm). */
export const previousPeriod = (t: Data, year: number, month: number): { year: number; month: number } =>
  t.frequency === 'yearly' ? { year: year - 1, month } : month === 1 ? { year: year - 1, month: 12 } : { year, month: month - 1 };

